/**
 * Labstep
 *
 * @module core/SequenceEditor
 * @desc Imports (lazy) sequence editor in error boundary
 */

import { ErrorBoundaryContainer } from 'labstep-web/containers/ErrorBoundary';
import React, { Suspense } from 'react';
import type { ISequenceEditorProps } from './types';

export const SequenceEditorComponent = React.lazy(() =>
  import('./component').then((module) => ({
    default: module.SequenceEditor,
  })),
);

export const SequenceEditor: React.FC<ISequenceEditorProps> = (
  props,
) => (
  <ErrorBoundaryContainer FallbackComponent={<div />}>
    <Suspense fallback={<div />}>
      <SequenceEditorComponent {...props} />
    </Suspense>
  </ErrorBoundaryContainer>
);
